import React, { memo, ReactNode, useCallback, useMemo, useState } from 'react';
import { VehiclesSearch } from '@app/common';
import { useNavigate } from 'react-router-dom';
import { Button } from '@app/components';
import { IconPlusCircle24 } from '@app/icons';
import { ModalTenderCreate } from '@app/modals';
import { Tender, TenderCategory, UserType, Vehicle } from '@app/models';
import { useUserContext } from '@app/providers';

interface Props {}

function PageProfileVehicles() {
  const { user, company } = useUserContext();
  const navigate = useNavigate();
  const [modalTenderCreateVisible, setModalTenderCreateVisible] =
    useState<boolean>(false);

  const onClickTender = useCallback(
    (id: string) => {
      navigate(`/profile/tender/${id}`);
    },
    [navigate]
  );

  const onClickCreate = useCallback(() => {
    setModalTenderCreateVisible(true);
  }, []);

  const closeModalTenderCreate = useCallback(() => {
    setModalTenderCreateVisible(false);
  }, []);

  const onClickReplies = useCallback(() => {
    navigate(`/profile/tender/${TenderCategory.VEHICLE}/replies`);
  }, [navigate]);

  const controls = useMemo<ReactNode[]>(
    () => [
      <div
        key="controls"
        className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto"
      >
        <Button
          key="replies"
          text="Перейти в список моих откликов"
          onClick={onClickReplies}
          className="flex-1 min-w-0 sm:min-w-[200px]"
        />
        <Button
          key="create"
          text="Создать объявление"
          icon={IconPlusCircle24}
          onClick={onClickCreate}
          className="flex-1 min-w-0 sm:min-w-[200px]"
        />
      </div>,
    ],
    [onClickCreate, onClickReplies]
  );

  const defaultParams = useMemo<Partial<Vehicle | Tender>>(() => {
    const paramsToReturn: Partial<Vehicle | Tender> = {};

    if (user.type === UserType.ENTITY) {
      paramsToReturn.companyId = company!.id;
    } else {
      paramsToReturn.ownerId = user.id;
    }

    return paramsToReturn;
  }, [user, company]);

  return (
    <>
      <VehiclesSearch
        onClick={onClickTender}
        columns={4}
        title="Спецтехника"
        controls={controls}
        defaultParams={defaultParams}
        okedParentNumber={80000001}
      />
      <ModalTenderCreate
        companyId={!!company ? company.id : null}
        visible={modalTenderCreateVisible}
        closeModal={closeModalTenderCreate}
        tenderCategory={TenderCategory.VEHICLE}
      />
    </>
  );
}

export default memo(PageProfileVehicles);
